import DataService from './data-service';
import axios, { API_URL } from './http-service';

export default class AuthService extends DataService {

  login = async (username: string, password: string) => {
    const url = API_URL + '/users/login';
    return this.handler(() => axios.post(url, { username, password }));
  }

  loginAlternate = async (userId: string, adminPassword: string) => {
    const url = API_URL + '/users/login-alternate';
    return this.handler(() => axios.post(url, { userId, adminPassword }));
  }

  resetPassword = async (password: string) => {
    const url = API_URL + '/users/password';
    return this.handler(() => axios.put(url, { password }));
  }

  forgetPassword = async (phoneNumber: string) => {
    const url = API_URL + '/users/password/' + phoneNumber;
    return this.handler(() => axios.get(url));
  }

}
